"use strict";
/*
 * Created on 31.08.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Tomas Leity
 * @author Radek Beran
 */

var KpiDataStructureEnum;

(function (KpiDataStructureEnum) {
  KpiDataStructureEnum["PromoSalesUser"] = "PromoSalesUser";
  KpiDataStructureEnum["PromoSalesSystem"] = "PromoSalesSystem";
  KpiDataStructureEnum["PromoSalesReal"] = "PromoSalesReal";
  KpiDataStructureEnum["PromoSalesDeltaUser"] = "PromoSalesDeltaUser";
  KpiDataStructureEnum["PromoSalesDeltaSystem"] = "PromoSalesDeltaSystem";
  KpiDataStructureEnum["PromoSalesLiftUser"] = "PromoSalesLiftUser";
  KpiDataStructureEnum["PromoSalesLiftSystem"] = "PromoSalesLiftSystem";
  KpiDataStructureEnum["PromoSalesLiftReal"] = "PromoSalesLiftReal";
  KpiDataStructureEnum["PromoSalesIncrementUser"] = "PromoSalesIncrementUser";
  KpiDataStructureEnum["PromoSalesIncrementSystem"] = "PromoSalesIncrementSystem";
  KpiDataStructureEnum["PromoSalesIncrementReal"] = "PromoSalesIncrementReal";
  KpiDataStructureEnum["PromoSalesEffectiveIncrementUser"] = "PromoSalesEffectiveIncrementUser";
  KpiDataStructureEnum["PromoSalesEffectiveIncrementSystem"] = "PromoSalesEffectiveIncrementSystem";
  KpiDataStructureEnum["PromoSalesEffectiveIncrementReal"] = "PromoSalesEffectiveIncrementReal";
  KpiDataStructureEnum["PromoPurchaseReal"] = "PromoPurchaseReal";
  KpiDataStructureEnum["VolumeUser"] = "VolumeUser";
  KpiDataStructureEnum["VolumeSystem"] = "VolumeSystem";
  KpiDataStructureEnum["VolumeReal"] = "VolumeReal";
  KpiDataStructureEnum["VolumeDeltaUser"] = "VolumeDeltaUser";
  KpiDataStructureEnum["VolumeDeltaSystem"] = "VolumeDeltaSystem";
  KpiDataStructureEnum["VolumeLiftUser"] = "VolumeLiftUser";
  KpiDataStructureEnum["VolumeLiftSystem"] = "VolumeLiftSystem";
  KpiDataStructureEnum["VolumeLiftReal"] = "VolumeLiftReal";
  KpiDataStructureEnum["GrossMarginUser"] = "GrossMarginUser";
  KpiDataStructureEnum["GrossMarginSystem"] = "GrossMarginSystem";
  KpiDataStructureEnum["GrossMarginReal"] = "GrossMarginReal";
  KpiDataStructureEnum["GrossMarginUserRel"] = "GrossMarginUserRel";
  KpiDataStructureEnum["GrossMarginSystemRel"] = "GrossMarginSystemRel";
  KpiDataStructureEnum["GrossMarginRealRel"] = "GrossMarginRealRel";
  KpiDataStructureEnum["GrossMarginDeltaUserRel"] = "GrossMarginDeltaUserRel";
  KpiDataStructureEnum["GrossMarginDeltaSystemRel"] = "GrossMarginDeltaSystemRel";
  KpiDataStructureEnum["GrossMarginBaseline"] = "GrossMarginBaseline";
  KpiDataStructureEnum["GrossMarginBaselineRel"] = "GrossMarginBaselineRel";
  KpiDataStructureEnum["BMProxyUser"] = "BMProxyUser";
  KpiDataStructureEnum["BMProxySystem"] = "BMProxySystem";
  KpiDataStructureEnum["BMProxyReal"] = "BMProxyReal";
  KpiDataStructureEnum["BMProxyUserRel"] = "BMProxyUserRel";
  KpiDataStructureEnum["BMProxySystemRel"] = "BMProxySystemRel";
  KpiDataStructureEnum["BMProxyRealRel"] = "BMProxyRealRel";
  KpiDataStructureEnum["BMProxyDeltaUserRel"] = "BMProxyDeltaUserRel";
  KpiDataStructureEnum["BMProxyDeltaSystemRel"] = "BMProxyDeltaSystemRel";
  KpiDataStructureEnum["BMIncrementUser"] = "BMIncrementUser";
  KpiDataStructureEnum["BMIncrementSystem"] = "BMIncrementSystem";
  KpiDataStructureEnum["BMIncrementReal"] = "BMIncrementReal";
  KpiDataStructureEnum["BMEffectiveIncrementUser"] = "BMEffectiveIncrementUser";
  KpiDataStructureEnum["BMEffectiveIncrementSystem"] = "BMEffectiveIncrementSystem";
  KpiDataStructureEnum["BMEffectiveIncrementReal"] = "BMEffectiveIncrementReal";
  KpiDataStructureEnum["PromoShareRealRel"] = "PromoShareRealRel";
  KpiDataStructureEnum["GmAndBackDiscountRealRel"] = "GmAndBackDiscountRealRel";
  KpiDataStructureEnum["NumberOfPromoArticlesReal"] = "NumberOfPromoArticlesReal";
  KpiDataStructureEnum["AngNumberOfArticlesReal"] = "AngNumberOfArticlesReal";
  KpiDataStructureEnum["StockValueAfter"] = "StockValueAfter";
  KpiDataStructureEnum["StockValueBefore"] = "StockValueBefore";
  KpiDataStructureEnum["StockValueDelta"] = "StockValueDelta";
  KpiDataStructureEnum["StockVolumeAfter"] = "StockVolumeAfter";
  KpiDataStructureEnum["StockVolumeBefore"] = "StockVolumeBefore";
  KpiDataStructureEnum["SegmentationUser"] = "SegmentationUser";
  KpiDataStructureEnum["SegmentationSystem"] = "SegmentationSystem";
  KpiDataStructureEnum["SegmentationReal"] = "SegmentationReal";
  KpiDataStructureEnum["CannibalizationSystem"] = "CannibalizationSystem";
  KpiDataStructureEnum["CannibalizationReal"] = "CannibalizationReal";
  KpiDataStructureEnum["CannibalizationSystemRel"] = "CannibalizationSystemRel";
  KpiDataStructureEnum["CannibalizationRealRel"] = "CannibalizationRealRel";
  KpiDataStructureEnum["PostPromoEffectSystem"] = "PostPromoEffectSystem";
  KpiDataStructureEnum["PostPromoEffectReal"] = "PostPromoEffectReal";
  KpiDataStructureEnum["PostPromoEffectSalesSystem"] = "PostPromoEffectSalesSystem";
  KpiDataStructureEnum["PostPromoEffectSalesReal"] = "PostPromoEffectSalesReal";
  KpiDataStructureEnum["ReceiptNumbers"] = "ReceiptNumbers";
  KpiDataStructureEnum["ReceiptPenetration"] = "ReceiptPenetration";
  KpiDataStructureEnum["ReceiptAverageSales"] = "ReceiptAverageSales";
  KpiDataStructureEnum["ReceiptPromoShare"] = "ReceiptPromoShare";
  KpiDataStructureEnum["CherryPickingReceitpsRel"] = "CherryPickingReceitpsRel";
  KpiDataStructureEnum["CherryPicked"] = "CherryPicked";
  KpiDataStructureEnum["OnShelfAvailability"] = "OnShelfAvailability";
  KpiDataStructureEnum["OverstockValueBefore"] = "OverstockValueBefore";
  KpiDataStructureEnum["OverstockValueAfter"] = "OverstockValueAfter";
  KpiDataStructureEnum["OverstockValueDelta"] = "OverstockValueDelta";
  KpiDataStructureEnum["ForecastAccuracyUser"] = "ForecastAccuracyUser";
  KpiDataStructureEnum["ForecastAccuracySystem"] = "ForecastAccuracySystem";
  KpiDataStructureEnum["ForecastCm"] = "ForecastCm";
  KpiDataStructureEnum["VendorAllowanceUser"] = "VendorAllowanceUser";
  KpiDataStructureEnum["VendorAllowanceSystem"] = "VendorAllowanceSystem";
  KpiDataStructureEnum["VendorAllowanceReal"] = "VendorAllowanceReal";
  KpiDataStructureEnum["BackDiscountUser"] = "BackDiscountUser";
  KpiDataStructureEnum["BackDiscountSystem"] = "BackDiscountSystem";
  KpiDataStructureEnum["BackDiscountReal"] = "BackDiscountReal";
  KpiDataStructureEnum["BaselineSales"] = "BaselineSales";
  KpiDataStructureEnum["SupplierPromoContribution"] = "SupplierPromoContribution"; // Not implemented yet

  KpiDataStructureEnum["ShrinkTotalReal"] = "ShrinkTotalReal";
  KpiDataStructureEnum["DayStockLeft"] = "DayStockLeft"; // Custom KPI-like fields send with other KPI for SDR

  KpiDataStructureEnum["SalesURDifference"] = "SalesURDifference";
  KpiDataStructureEnum["GMURDifference"] = "GMURDifference";
  KpiDataStructureEnum["PricePromo"] = "PricePromo";
  KpiDataStructureEnum["PricePurchasePromo"] = "PricePurchasePromo";
  KpiDataStructureEnum["PricePurchasePromoPlus"] = "PricePurchasePromoPlus";
  KpiDataStructureEnum["PricePurchaseRegular"] = "PricePurchaseRegular";
  KpiDataStructureEnum["PriceRegular"] = "PriceRegular";
  KpiDataStructureEnum["POSMarginImpact"] = "POSMarginImpact";
})(KpiDataStructureEnum = exports.KpiDataStructureEnum || (exports.KpiDataStructureEnum = {}));